module.exports = __webpack_public_path__ + "img/25.2ab91cd8.jpg";